.empty-state-data-display_wrapper {
  align-items: center;
  background-color: var(--color-uva-white);
  display: flex;
  gap: 1.5rem;
  padding: 1.5rem;
}

.empty-state-data-display_icon-frame {
  align-items: center;
  background-color: var(--color-grey-200);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  min-height: 4rem;
  min-width: 4rem;
}

.empty-state-data-display_wrapper--invert-colors {
  background-color: var(--color-grey-200);
}

.empty-state-data-display_wrapper--slim {
  gap: 1rem;
  padding: 1rem;
}

.empty-state-data-display_icon-frame--invert-colors {
  background-color: var(--color-uva-white);
}

.empty-state-data-display_icon-frame--slim {
  min-height: 2rem;
  min-width: 2rem;
}

.empty-state-data-display_text-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.empty-state-data-display_label {
  font-weight: var(--semibold);
}

.empty-state-data-display_paragraph {
  color: var(--color-grey-700);
  margin: 0;
}
